import { render, staticRenderFns } from "./invoice_temp1.vue?vue&type=template&id=78b37912&scoped=true&"
import script from "./invoice_temp1.vue?vue&type=script&lang=js&"
export * from "./invoice_temp1.vue?vue&type=script&lang=js&"
import style0 from "./invoice_temp1.vue?vue&type=style&index=0&id=78b37912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b37912",
  null
  
)

export default component.exports